/*eslint-disable*/
import axios from 'axios';
import Cookies from 'js-cookie';
import { API } from '../../config/api';
import actions from './actions';

const { loginBegin, loginSuccess, loginErr, logoutBegin, logoutSuccess, logoutErr } = actions;


const login = (credentials) => {
  return async (dispatch) => {
    try {
      dispatch(loginBegin());
      const response = await axios.post(`${API.auth.login}`, credentials);
      const { data } = response;
      Cookies.set('logedIn', JSON.stringify(data), { expires: 7 });
      Cookies.set('token', data.token, { expires: 7 });
      Cookies.set('userId', data.user.id, { expires: 7 });
      dispatch(loginSuccess(data));
      return Promise.resolve();
    } catch (err) {
      const errorMessage = err.response?.data?.message || 'Login failed. Please try again.';
      dispatch(loginErr(errorMessage));
      return Promise.reject(errorMessage);
    }
  };
};

const logOut = () => {
  return async (dispatch) => {
    try {
      dispatch(logoutBegin());
      Cookies.remove('logedIn');
      dispatch(logoutSuccess(null));
    } catch (err) {
      dispatch(logoutErr(err));
    }
  };
};


export { login, logOut };

